import React from "react";
import styled from "styled-components";
import useGetThemeComponentColor from "../../../hooks/useGetThemeComponentColor";
import useGetThemeComponentTypography from "../../../hooks/useGetThemeComponentTypography";
import { TypeColorNames } from "../../../theme/colors";
import { TypographyTypes } from "../../../theme/typography";

const StyledTypography = styled.span``;
export interface ITypography {
  type: TypographyTypes;
  color: TypeColorNames;
  customColor?: string;
  children: any;
  style?: React.CSSProperties;
  className?: string;
}

const DEFAULT_TYPOGRAPHY = "body1";
const DEFAULT_COLOR = "darkBackground";

const Typography = ({
  type,
  color,
  children,
  style,
  className,
  customColor,
  ...props
}: ITypography) => {
  const getTypographyType = useGetThemeComponentTypography();
  const getColor = useGetThemeComponentColor();

  return (
    <StyledTypography
      className={className || "eventials-typography"}
      style={{ ...getTypographyType(type), color: (customColor || getColor(color)), ...style }}
      {...props}
    >
      {children}
    </StyledTypography>
  );
};

Typography.defaultProps = {
  type: DEFAULT_TYPOGRAPHY,
  color: DEFAULT_COLOR,
};

export default Typography;
